import React, { useState } from 'react'
import BigNumber from 'bignumber.js'
import { Button, Flex, TokenAmount, Skeleton } from 'vvs-uikit'
import { useTranslation } from 'contexts/Localization'
import { useAppDispatch } from 'state'
import { fetchFarmUserDataAsync } from 'state/farms'
import useToast from 'hooks/useToast'
import { getBalanceAmount } from 'utils/formatBalance'
import { BIG_ZERO } from 'utils/bigNumber'
import { useWeb3React } from '@web3-react/core'
import { usePriceVvsUsdc } from 'state/farms/hooks'
import LocalBalance from 'components/LocalBalance'
import { isBlindMode } from 'utils'
import useHarvestFarm from '../../hooks/useHarvestFarm'

interface FarmCardActionsProps {
  earnings?: BigNumber
  pid?: number
}

const HarvestAction: React.FC<FarmCardActionsProps> = ({ earnings, pid }) => {
  const { account } = useWeb3React()
  const { toastSuccess, toastError } = useToast()
  const { t } = useTranslation()
  const [pendingTx, setPendingTx] = useState(false)
  const { onReward } = useHarvestFarm(pid)
  const vvsPrice = usePriceVvsUsdc()
  const dispatch = useAppDispatch()
  const rawEarningsBalance = account ? getBalanceAmount(earnings) : BIG_ZERO
  // const displayBalance = rawEarningsBalance.toFixed(3, BigNumber.ROUND_DOWN)
  const earningsUsdc = rawEarningsBalance ? rawEarningsBalance.multipliedBy(vvsPrice) : BIG_ZERO

  return (
    <Flex mb="8px" justifyContent="space-between" alignItems="center">
      <Flex flexDirection="column" alignItems="flex-start">
        <TokenAmount color={rawEarningsBalance.eq(0) ? 'textDisabled' : 'text'}>
          {rawEarningsBalance.toNumber().toLocaleString('en-US', { maximumFractionDigits: 3 })}
        </TokenAmount>
        {earningsUsdc.gt(0) && isBlindMode() ? (
          <Skeleton mt={1} width={60} />
        ) : (
          earningsUsdc.gt(0) && (
            <LocalBalance fontSize="12px" color="textSubtle" decimals={2} value={earningsUsdc} prefix="~" />
          )
        )}
      </Flex>
      <Button
        disabled={rawEarningsBalance.eq(0) || pendingTx}
        onClick={async () => {
          setPendingTx(true)
          try {
            await onReward()
            toastSuccess(
              `${t('Harvested')}!`,
              t('Your %symbol% earnings have been sent to your wallet!', { symbol: 'VVS' }),
            )
          } catch (e) {
            toastError(
              t('Error'),
              t(
                'The network may be congested. Please try again and confirm the transaction. Do not change the default gas transactions settings for Cronos as it will not help to speed up.',
              ),
            )
            console.error(e)
          } finally {
            setPendingTx(false)
          }
          dispatch(fetchFarmUserDataAsync({ account, pids: [pid] }))
        }}
      >
        {t('Harvest')}
      </Button>
    </Flex>
  )
}

export default HarvestAction
